export default "__VITE_ASSET__CwKMR8EI__"